/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Groupcount1Inputs */



/**
* | output |
* | --- |
* | "Number of groups" |
*
* @param {Br_History_Key_Groupcount1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_groupcount1 = /** @type {((inputs?: Br_History_Key_Groupcount1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Groupcount1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Number of groups")
	return /** @type {LocalizedString} */ ("Nombre de groupes")
});
export { br_history_key_groupcount1 as "br_history_key_groupCount" }